import { LOCATION_CHANGE } from 'connected-react-router'
import moment from 'moment'
import { ofType } from 'redux-observable'
import { of } from 'rxjs'
import { distinctUntilChanged, filter, map, switchMap } from 'rxjs/operators'
import { hasNoCypher } from 'domain/router'
import { getMomentLocale, scriptPromise } from 'locale/moment'
import * as Actions from 'store/actions/index.ts'
import { getURILocale } from 'store/selectors'

export default (actions$, state$) => actions$.pipe(
  ofType(LOCATION_CHANGE),
  filter(hasNoCypher),
  map(() => getURILocale(state$.value)),
  distinctUntilChanged(),
  switchMap(locale => {
    const { isAlreadyFetched, momentLocale, url } = getMomentLocale(locale)

    if (!isAlreadyFetched) {
      return scriptPromise(url, momentLocale)
    }
    return of(momentLocale)
  }),
  switchMap(momentLocale => {
    moment.locale(momentLocale)

    return of(Actions.application.onSetMomentLocale())
  })
)
